<!--Main-->
<template>
  <div class="table-content" :class="className"><!-- v-if="data"-->
    <!-- 显示表格 -->
    <el-table
      ref="multipleTable"
      :key="tableKey"
      v-loading="listInfo.loading"
      :max-height="tableHeight || undefined"
      :data="data"
      :span-method="handle && handle.spanMethod"
      border
      style="width:100%"
      element-loading-text="Loading"
      fit
      size="mini"
      highlight-current-row
      @select-all="handleSelectionChange"
      @selection-change="handleSelectionChange"
    >
      <template v-for="(item, index) in fieldList">
        <template v-if="item.show">
          <!-- 多选框按钮 -->
          <el-table-column
            v-if="item.btType == 'selection'"
            :key="index"
            type="selection"
            :selectable="item.checkSelectSet"
            width="55"
          />
          <!-- 图标按钮 -->
          <el-table-column
            v-else-if="item.btType == 'actions'"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :fixed="item.fixed"
            :type="item.type"
            :width="item.width"
            :min-width="item.minWidth || '100px'"
            :formatter="item.formatter"
          >
            <template slot-scope="scope">
              <template v-for="(bt,i) in handle.btList">
                <el-tooltip
                  v-if="!data[scope.$index].btns || (data[scope.$index].btns && data[scope.$index].btns[i] !== false)"
                  :key="i"
                  class="item"
                  :content="bt.label"
                  placement="bottom-start"
                  :disabled="
                    scope.row.btns &&
                    scope.row.btns[i] &&
                    scope.row.btns[i].disabled"
                >
                  <el-button
                    plain
                    size="mini"
                    :type="bt.type"
                    :icon="bt.icon"
                    circle
                    :disabled="
                    scope.row.btns &&
                    scope.row.btns[i] &&
                    scope.row.btns[i].disabled"
                    @click="handleClick(bt.event, scope.row)"
                  >
                    <svg-icon v-if="bt.iconClass" :icon-class="bt.iconClass" />
                  </el-button><!--:disabled="(scope.row[bt.name] && scope.row[bt.name].disabled) || bt.disabled"-->
                </el-tooltip>
              </template>
            </template>
          </el-table-column>

          <!-- 链接按钮 -->
          <el-table-column
            v-else-if="item.btType == 'link'"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :fixed="item.fixed"
            :type="item.type"
            :width="item.width"
            :min-width="item.minWidth || '100px'"
            :formatter="item.formatter"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="handleClick(item.event, scope.row)"
              >{{ scope.row[item.prop] }}</el-link>
            </template>
          </el-table-column>

          <!-- 普通输入框 -->
          <el-table-column
            v-else-if="item.btType == 'input'"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :fixed="item.fixed"
            :type="item.type"
            :width="item.width"
            :min-width="item.minWidth || '100px'"
            :formatter="item.formatter"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-input
                :placeholder="`请输入${item.label}`"
                v-model="data[scope.$index][item.prop]"
                size="mini"
                :disabled="item.disabled || data[scope.$index].disabled || data[scope.$index][`${item.prop}Disabled`]"
              />
            </template>
          </el-table-column>

          <!-- 选择器 -->
          <el-table-column
            v-else-if="item.btType === 'daterange'"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            show-overflow-tooltip>
            <!-- 日期范围选择 -->
            <template slot-scope="scope">
            <el-date-picker
              v-model="data[scope.$index][item.value]"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="item.options"
            />
            </template>
          </el-table-column>

          <!-- 新增列 -->
          <el-table-column
            v-else-if="item.btType == 'add'"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :fixed="item.fixed"
            :type="item.type"
            :width="item.width"
            :min-width="item.minWidth || '100px'"
            :formatter="item.formatter"
            show-overflow-tooltip
            align="right"
          >
            <template slot="header">
              <el-button
                @click="handleClick(item.addEvent)"
                type="info"
                class="el-icon-plus"
                size="mini"
              />
            </template>
            <template slot-scope="scope">
              <el-button
                @click="handleClick(item.removeEvent, scope)"
                size="mini"
                type="danger"
                class="el-icon-minus"
                fixed
              />
            </template>
          </el-table-column>

          <template v-else>
            <el-table-column
              v-if="item.type == 'index'"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :fixed="item.fixed"
              :type="item.type"
              :width="item.width"
              :min-width="item.minWidth || '100px'"
              :formatter="item.formatter"
              show-overflow-tooltip
            />
            <el-table-column
              v-else
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :fixed="item.fixed"
              :type="item.type"
              :width="item.width"
              :min-width="item.minWidth || '100px'"
              :formatter="item.formatter"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span
                  :style="`color: ${scope.row.showColor && item.color};`"
                >{{scope.row[item.prop]}}</span>
              </template>
            </el-table-column>
          </template>
        </template>
      </template>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "Main",
  props: {
    // 自定义类名
    className: {
      type: String,
    },
    // 类型列表
    listTypeInfo: {
      type: Object,
    },
    // 表格字段配置
    fieldList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 操作栏配置
    handle: {
      type: Object,
    },
    // 列表数据
    data: {
      type: Array,
    },
    //table标识
    tableKey: {
      type: Number,
    },
    // 监听高度
    height: {
      type: Number,
      default: 500,
    },
    contentHeight: {
      type: Number,
      default: 550,
    },
    toggleRowSelections: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      // 列表相关
      listInfo: {
        loading: false, // 加载动画
      },
      tableHeight: 0,
    };
  },
  watch: {
    height(value) {
      const navH = document.getElementsByClassName("navbar")[0]
        ? document.getElementsByClassName("navbar")[0].clientHeight
        : 0;
      const tagH = document.getElementsByClassName("tags-view-container")[0]
        ? document.getElementsByClassName("tags-view-container")[0].clientHeight
        : 0;
      const searchH = document.getElementsByClassName(
        "fn-layout-vertical-form"
      )[0]
        ? document.getElementsByClassName("fn-layout-vertical-form")[0]
            .clientHeight
        : 0;
      const pagerH = document.getElementsByClassName(
        "fn-layout-vertical-operation"
      )[0]
        ? document.getElementsByClassName("fn-layout-vertical-operation")[0]
            .clientHeight
        : 0;
      const bottomH = document.getElementsByClassName(
        "fn-layout-vertical-pagination"
      )[0]
        ? document.getElementsByClassName("fn-layout-vertical-pagination")[0]
            .clientHeight
        : 0;
      if (value) {
        this.tableHeight =
          window.innerHeight - (navH + tagH + searchH + pagerH + bottomH);
      }
    },
    contentHeight(value) {
      const navH = document.getElementsByClassName("navbar")[0]
        ? document.getElementsByClassName("navbar")[0].clientHeight
        : 0;

      const tagH = document.getElementsByClassName("tags-view-container")[0]
        ? document.getElementsByClassName("tags-view-container")[0].clientHeight
        : 0;
      const searchH = document.getElementsByClassName(
        "fn-layout-vertical-form"
      )[0]
        ? document.getElementsByClassName("fn-layout-vertical-form")[0]
            .clientHeight
        : 0;
      const pagerH = document.getElementsByClassName(
        "fn-layout-vertical-operation"
      )[0]
        ? document.getElementsByClassName("fn-layout-vertical-operation")[0]
            .clientHeight
        : 0;
      const bottomH = document.getElementsByClassName(
        "fn-layout-vertical-pagination"
      )[0]
        ? document.getElementsByClassName("fn-layout-vertical-pagination")[0]
            .clientHeight
        : 0;

      const tabH = document.getElementsByClassName("el-tabs__header")[0]
        ? document.getElementsByClassName("el-tabs__header")[0].clientHeight
        : 0;

      if (value) {
        this.tableHeight =
          window.innerHeight -
          (navH + tagH + searchH + pagerH + bottomH + tabH + 65);
      }
    },
    //toggleRowSelections
    data: {
      handler: function (val) {
        this.$emit("update:refObj", this.$refs.table);
        this.$nextTick(() => {
          this.toggleRowData();
        });
      },
      deep: true, // 深度监听
    },
    // toggleRowSelections: {
    //   handler: function (val) {
    //     alert('深度')
    //     this.$emit('update:refObj', this.$refs.table)
    //   },
    //   deep: true // 深度监听
    // },
  },
  mounted() {
    this.$emit("update:refObj", this.$refs.table);
    this.toggleRowData();
  },
  methods: {
    handleSizeChange(val) {
      const query = this.listInfo.query;
      query.pageSize = val; // 每页条数
      query.curPage = 1; // 每页条数切换，重置当前页
    },
    handleCurrentChange(val) {
      this.listInfo.query.curPage = val; // 当前页
    },
    // 派发按钮点击事件
    handleClick(event, data) {
      this.$emit("handleClick", event, data);
    },
    // 选中数据
    handleSelectionChange(rows) {
      this.$emit("handleEvent", "tableCheck", rows);
    },
    //
    toggleRowData() {
      this.$emit("update:refObj", this.$refs.table);
      //
      if (this.toggleRowSelections && this.data) {
        this.data.forEach((item, index) => {
          this.toggleRowSelections.forEach((items, indexs) => {
            if (this.data[index].id === this.toggleRowSelections[indexs]) {
              this.$refs.table.toggleRowSelection(this.data[index], true);
            } else if (
              this.data[index].pageOpId === this.toggleRowSelections[indexs]
            ) {
              this.$refs.table.toggleRowSelection(this.data[index], true);
            } else if (
              this.data[index].roleId === this.toggleRowSelections[indexs]
            ) {
              this.$refs.table.toggleRowSelection(this.data[index], true);
            }
          });
        });
      }
      //
    },
    // 得到placeholder的显示
    getPlaceholder(row) {
      let placeholder;
      if (row.type === "input" || row.type === "textarea") {
        placeholder = "请输入" + row.label;
      } else if (
        row.type === "select" ||
        row.type === "time" ||
        row.type === "date" ||
        row.type === "picker"
      ) {
        placeholder = "请选择" + row.label;
      } else if (row.type === "number") {
        placeholder = "请输入数字";
      } else {
        placeholder = row.label;
      }
      return placeholder;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/table.vue